#import "../fragments/email-sequence-template-fragment.graphql"

mutation UndeleteEmailSequenceTemplate($sequenceTemplate: EmailSequenceTemplateUndeleteInput!) {
    emailSequenceTemplateUndelete(input: $sequenceTemplate) {
        emailSequenceTemplate {
            ...EmailSequenceTemplate
        }
    }
}
